<template>
  <div>
    <parsed-panel v-if="data" :data="data"/>
    <div v-if="!data">{{ hint }}</div>
  </div>
</template>

<script>
import ParsedPanel from './ParsedPanel.vue'
import { parseByUserIdAndStartAt } from '@/services/MhService'

export default {
  components: {
    ParsedPanel
  },
  data () {
    return {
      data: null,
      hint: 'loading...'
    }
  },
  mounted: async function () {
    try {
      const userId = this.$route.query.userId
      const startAt = this.$route.query.startAt
      const end = this.$route.query.end || 0

      const res = await parseByUserIdAndStartAt(userId, startAt, end)
      console.log(res.data)
      if (res.data.result) {
        this.data = res.data.result
      } else {
        this.hint = 'no data!'
      }
    } catch (err) {
      console.error(err)
      this.hint = 'no data!'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ParsemhAt.vue